<mat-icon [svgIcon]="iconSvg" [class]="styleClass"> </mat-icon>
